module.exports = __webpack_public_path__ + "img/76.caa7809.png";